<template>
  <form class="s-footer-newsletter" novalidate @submit.prevent="submit">
    <SEmail
      v-model="email"
      :aria-label="tr('main_site.layout.footer_newsletter_title')"
      class="s-footer-newsletter__email"
      name="email"
      :placeholder="tr('main_site.layout.footer_newsletter_email_placeholder')"
      required
      show-required-type="none"
      :size="isWide ? 'small' : undefined"
    />

    <SSubmitMessage
      :error-message="tr('main_site.layout.footer_newsletter_submit_error')"
      :status="status"
      :success-message="tr('main_site.layout.footer_newsletter_submit_success')"
    >
      <SButton
        v-if="status !== 'success'"
        class="s-footer-newsletter__submit"
        color="accent"
        :loading="asyncStatus === 'loading'"
        :size="isWide ? 'sm' : 'md'"
        suffix-icon="fa-regular fa-arrow-right"
        type="submit"
      >
        {{ tr("main_site.layout.footer_newsletter_cta") }}
      </SButton>
    </SSubmitMessage>
  </form>
</template>

<script setup lang="ts">
import { useMutation } from "@pinia/colada";
import { useMediaQuery } from "@vueuse/core";
import { ref } from "vue";

import { SButton } from "@solvari/common-fe";
import { useValidationObserver } from "@solvari/common-fe/validation";
import { useI18nMainSiteLayout } from "@solvari/translations";

import { useSubscribeToNewsletter } from "@/api/footerNewsletter.ts";
import SSubmitMessage from "@/atoms/SSubmitMessage.vue";
import SEmail from "@/molecules/SEmail.vue";

const email = ref("");

const { tr } = useI18nMainSiteLayout();

const isWide = useMediaQuery("(min-width: 1000px)", { ssrWidth: 768 });

const { mutate, asyncStatus, status } = useMutation(useSubscribeToNewsletter());

const { handleSubmit } = useValidationObserver();
function submit() {
  void handleSubmit(() => mutate({ email: email.value }));
}
</script>

<style lang="postcss">
.s-footer-newsletter {
  @apply flex flex-col gap-1;

  .s-label {
    @apply text-base text-white;
  }

  &__submit {
    @apply w-full;
  }

  @screen 700 {
    @apply flex-row items-end;

    &__email {
      @apply grow;
    }

    &__submit {
      @apply w-auto;
    }
  }

  @screen 1000 {
    @apply flex-col items-stretch;

    &__submit {
      @apply w-full;
    }
  }
}
</style>
